import './Thanks.scss';
import Component from './Thanks.js';
export default Component;
